function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M14.887 20.135H17.6l3.722-3.722a.958.958 0 000-1.356L19.966 13.7a.958.958 0 00-1.356 0l-3.722 3.722v2.713h-.001z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.674 10.562v-4.79M11.039 16.322H5.283a1.92 1.92 0 01-1.92-1.92V5.746",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M17.745 3.815H5.293a1.93 1.93 0 00-1.93 1.931v0c0 .64.318 1.238.848 1.597l5.14 3.486a3.867 3.867 0 004.34 0l5.138-3.485a1.93 1.93 0 00.847-1.597v-.001a1.93 1.93 0 00-1.93-1.93z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEmailEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgEmailEdit;